import { useCallback } from "react";
import { TokenCell } from "../../../components/grid/cells/TokenCell";
import { Toolbar } from "../../../components/Toolbar";
import { AdministrateExportButton } from "../../components/AdministrateExportButton";
import { AdministrateTable } from "../../components/AdministrateTable";
import { makeColumns, useAdministrateTable, useUpdatePermission } from "../../utils";
import { AddCodeGroupMemberModal } from "../components/AddCodeGroupMemberModal";
import { CodeGroupCptCodeActionCell } from "../components/CodeGroupCptCodeActionCell";
import { ImportCodeGroupMembersModal } from "../components/ImportCodeGroupMembersModal";

const useColumns = makeColumns((codeGroupId) => [
  {
    id: "code",
    accessor: "code",
    Header: "Code",
    Cell: TokenCell,
  },
  {
    id: "description",
    accessor: "description",
    Header: "Short Description",
  },
  {
    id: "long_description",
    accessor: "longDescription",
    Header: "Long Description",
  },
  {
    id: "procedure_code_type",
    accessor: "procedureCodeType",
    Header: "Type",
    Cell: ({ value }) => value?.toUpperCase(),
  },
  {
    id: "actions",
    Header: "Actions",
    Cell: ({ row }) => <CodeGroupCptCodeActionCell codeGroupId={codeGroupId} {...row} />,
    disableFilters: true,
    disableSortBy: true,
  },
]);

export const CodeGroupsCptCodesTab = ({ codeGroup, codeGroupId }) => {
  const columns = useColumns(codeGroupId);
  const [canUpdate] = useUpdatePermission("CodeGroup", codeGroupId);

  const extraParams = { code_groups: { id: codeGroupId } };
  const { tableRef, allFilters, setTableFilters } = useAdministrateTable(extraParams);

  const onImport = useCallback(
    (message, details = []) => {
      tableRef.current?.refresh?.();
      tableRef.current?.setMessage?.(message, details.length ? "warning" : "success", details);
    },
    [tableRef]
  );

  const onAdd = useCallback(() => {
    tableRef.current?.refresh?.();
    tableRef.current?.setMessage?.(`New CPT Codes Added.`);
  }, [tableRef]);

  return (
    <>
      <Toolbar className="align-items-center mb-3">
        <Toolbar className="ms-auto">
          <AdministrateExportButton outline className="me-2" exportUrl={`/admin/code_groups/${codeGroupId}/cpt_codes.csv`} />
          {canUpdate && (
            <>
              <ImportCodeGroupMembersModal codeGroup={codeGroup} outline className="me-2" onImport={onImport} />
              <AddCodeGroupMemberModal codeGroup={codeGroup} onAdd={onAdd} />
            </>
          )}
        </Toolbar>
      </Toolbar>

      <AdministrateTable
        resourceUrl={"/admin/cpt_codes.json"}
        extraParams={extraParams}
        resourceName={"cpt_code"}
        onFilteredChange={setTableFilters}
        columns={columns}
        ref={tableRef}
      />
    </>
  );
};
